import React, { Component, Fragment } from 'react'
import { Mutation } from 'react-apollo'

import { UPDATE_ORDERPART } from '../../mutations'
import helpers from '../../helpers'

import Error from '../Error/'

import chevron from '../../assets/chevron-thin-down.svg'
import { InputContainer, Button, InputWrapper, StyledInput, Placeholder, Overlay, PlusButton, StyledSelect, InputCol, StyledLabel, SmallDescription, SmallDescriptionRight } from './styles'

class OrderInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      amount: this.props.order || 0,
      loading: false,
      selectValue: 1,
      matchingOrderPartId: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.updateChange = this.updateChange.bind(this)
    this.createOrderPart = this.createOrderPart.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  componentDidMount() {
    this.timer = null
  }

  // Update the orderPart when user has not typed for 1sec (update also occurs on blur)
  handleChange(e, orderPart) {
    clearTimeout(this.timer)
    
    const { selectValue } = this.state
    let amount = e.target.value > 0 ? e.target.value * selectValue : 0
    if (orderPart) {
      const matchingOrderPart = this.props.wholeOrder.orderParts.find(orderPart => orderPart.product.productCode === `81849-${this.props.product.productCode}`)
      this.setState({ amount, id: orderPart.id, matchingOrderPartId: matchingOrderPart ? matchingOrderPart.id : false })
      if (amount >= 0 && amount !== '') {
        this.timer = setTimeout(this.updateChange, 1000)
      }
    } else {
      // Create new orderpart
      if (amount >= 1 && amount !== '') {
        this.timer = setTimeout(this.createOrderPart(amount), 1000)
      }
    }
  }

  createOrderPart(amount) {
    const matchingOrderPart = this.props.wholeOrder.orderParts.find(orderPart => orderPart.product.productCode === `81849-${this.props.product.productCode}`)
    this.updateOrderPart({ variables: { data: { orderId: this.props.orderId, amount: amount, productCode: this.props.product.productCode } } }).then(() => {
      if (matchingOrderPart) {
        this.updateOrderPart({ variables: { data: { orderId: this.props.orderId, amount: amount, productCode: matchingOrderPart.product.productCode } } }).then(() => {
          window.location.reload()
        })
      } else {
        window.location.reload()
      }
    })
  }

  updateChange() {
    const { amount, id, matchingOrderPartId } = this.state
    this.setState({ loading: true })
    this.updateOrderPart({ variables: { data: { id, amount } } })

    if (matchingOrderPartId) {
      this.updateOrderPart({ variables: { data: { id: matchingOrderPartId, amount } } })
    }
  }

  createChange() {
    const { amount } = this.state
    const { product, wholeOrder } = this.props

    let orderPartNumber = wholeOrder.orderParts[wholeOrder.orderParts.length - 1].orderPartNumber
      ? Number(wholeOrder.orderParts[wholeOrder.orderParts.length - 1].orderPartNumber) + 10
      : 10
    this.setState({ loading: true })
    this.createOrderPart({
      variables: {
        data: {
          product: product.id,
          order: wholeOrder.id,
          amount,
          orderPartNumber
        }
      }
    })
  }

  handleSelect(e) {
    this.setState({ selectValue: e.target.value })
  }

  render() {
    const { product, orderPart, type, wholeOrder } = this.props
    const unit = helpers.translateUnits(product.unit)
    const packageUnit = helpers.translateUnits(product.packageUnit)
    let matchingSupOrderPart = wholeOrder.orderParts.find(orderPart => orderPart.product.productCode === `81849-${product.productCode}`)
    return (
      <Mutation
        mutation={UPDATE_ORDERPART}
        key={product.id}
        onCompleted={data => {
          this.setState({ loading: false })
        }}
      >
        {(updateOrderPart, { data, loading, error }) => {
          this.updateOrderPart = updateOrderPart
          if (error) {
            return <Error message={'Fout opgetreden bij het aanpassen van de bestelling.'} />
          }
          return (
            <InputContainer end={type === 'orderList'}>
              {this.state.amount >= 0 && type !== 'orderList' ? (
                <Button
                  onClick={e => {
                    if (this.state.amount > 0) {
                      if (orderPart) {
                        updateOrderPart({variables: { data: { id: orderPart.id, amount: orderPart.amount - 1 } }})
                        if (matchingSupOrderPart) {
                          updateOrderPart({variables: { data: { id: matchingSupOrderPart.id, amount: matchingSupOrderPart.amount - 1 }}})
                        }
                        this.setState({ amount: orderPart.amount - 1, loading: true })
                      } else {
                        // Create new orderpart
                      }
                    }
                  }}
                  data-amount="min"
                >
                  <span>-</span>
                </Button>
              ) : null}

              {product.packageAmount > 1 && (product.packageUnit !== product.unit) ? (
                <InputCol>
                  <StyledLabel>
                    Eenheid
                  </StyledLabel>
                  <StyledSelect value={this.state.selectValue} onChange={this.handleSelect} chevron={chevron}>
                    <option value={1}>
                      {unit.singular}
                    </option>
                    <option value={product.packageAmount}>
                      {packageUnit.singular}
                    </option>
                  </StyledSelect> 
                </InputCol>
              ) : null}

              <InputCol>
                {type === 'orderList' ? (
                  <StyledLabel>
                      Aantal
                  </StyledLabel>
                ) : null}
                <InputWrapper dropdown={product.packageAmount > 1 && (product.packageUnit !== product.unit)}>
                  <StyledInput
                    type="number"
                    value={this.state.amount >= 0 ? (this.state.amount / this.state.selectValue) : ''}
                    min="0"
                    max="10000"
                    onChange={e => {
                      this.handleChange(e, orderPart, updateOrderPart)
                    }}
                  />
                <Placeholder>
                  {type === 'orderList' && product.packageUnit === 'Doos' && product.unit === 'Doos' ? 'ds.' : 'st.'}
                </Placeholder>
                </InputWrapper>
              </InputCol>
              

                {type !== 'orderList' ? (
                  <PlusButton
                    onClick={e => {
                      if (orderPart) {
                        updateOrderPart({ variables: { data: { id: orderPart.id, amount: orderPart.amount + 1 } } })
                        if (matchingSupOrderPart) {
                          updateOrderPart({ variables: { data: { id: matchingSupOrderPart.id, amount: matchingSupOrderPart.amount + 1 }}})
                        }
                        this.setState({ amount: orderPart.amount + 1, loading: true })
                      } else {

                        // Create new orderpart
                        updateOrderPart({ variables: { data: { orderId: this.props.orderId, amount: 1, productCode: this.props.product.productCode } } }).then(() => {
                          matchingSupOrderPart = wholeOrder.orderParts.find(orderPart => orderPart.product.productCode === `81849-${this.props.product.productCode}`)
                          if (matchingSupOrderPart) {
                            updateOrderPart({ variables: { data: { orderId: this.props.orderId, amount: 1, productCode: matchingSupOrderPart.product.productCode } } }).then(() => {
                              window.location.reload()
                            })
                          } else {
                            window.location.reload()
                          }
                        })
                        this.setState({ amount: 1, loading: true })
                      }
                    }}
                    data-amount="plus"
                  >
                    <span>+</span>
                  </PlusButton>
                ) : null}
              {type === 'orderList' && product.packageAmount > 1 && (product.packageUnit !== product.unit) ? (
                <Fragment>
                  {this.state.selectValue > 1 ? (
                    <SmallDescription>{this.state.amount} {unit.plural} in {this.state.amount / this.state.selectValue} {(this.state.amount / this.state.selectValue) > 1 ? packageUnit.plural : packageUnit.singular}</SmallDescription>
                  ) : null}
                </Fragment>
              ) : null}
              {type === 'orderList' && product.packageUnit === 'Doos' && product.unit === 'Doos' ? (
                <SmallDescriptionRight>De aantallen zijn per doos en niet per stuk.</SmallDescriptionRight>
              ) : null}
              {this.state.loading ? <Overlay /> : null}
            </InputContainer>
          )
        }}
      </Mutation>
    )
  }
}

export default OrderInput



// WEBPACK FOOTER //
// ./src/components/OrderInput/index.js